/**
 * Created by mauget on 3/1/16.
 */

// OpenViewableInstanceDetailView.js

import $ from 'jquery';
import {View, Model} from 'backbone';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/forms/edit-forms-viewable-instance-detail-view.ejs';
import util from 'util/Util.js';
import restService      from 'RestService.js';
import PlayFormModal        from 'common-views/PlayFormModal.js';
import DataHistoryModal     from 'common-views/DataHistoryModal.js';
import MigrateFormInstanceModal     from 'dashboard/forms/modal/MigrateFormInstanceModal.js';
import eventBus  from 'EventBus';
import dashboardService from 'DashboardService';

class EditFormsViewableInstanceDetailView extends View {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;
        this.gridElNotifications = constants.PROP_MAIN_TABLE;
        this.gridElHistory = constants.PROP_MAIN_HISTORY;

        this.events = {
            'click #deleteForm': 'deleteFormInstance',
            'click #viewForm': 'viewForm',
            'click #dataHistory': 'dataHistory',
            'click #goToForms': 'goToForms',
            'click #goToEditForms': 'goToEditForms',
            'click #migrateFormInstance': 'migrateFormInstance'
        };

        this.model.set({
            colModelNotifications: [
                {
                    name: 'date',
                    index: 'date',
                    editable: false
                },
                {
                    name: 'time',
                    index: 'time',
                    editable: false
                },
                {
                    name: 'title',
                    index: 'title',
                    editable: false
                },
                {
                    name: 'person',
                    index: 'person',
                    editable: false
                },
                {
                    name: 'attentionLevel',
                    index: 'attentionLevel',
                    editable: false
                },
                {
                    name: 'notificationId',
                    index: 'notificationId',
                    editable: false,
                    hidden: true
                }

            ],
            colNamesNotifications: ['Date', 'Time', 'Title', 'Person', 'AttentionLevel','notificationId'],
            colModelHistory: [
                {
                    name: 'date',
                    index: 'date',
                    editable: false
                },
                {
                    name: 'time',
                    index: 'time',
                    editable: false
                },
                {
                    name: 'stage',
                    index: 'stage',
                    editable: false
                }, {
                    name: 'person',
                    index: 'person',
                    editable: false
                }
            ],
            colNamesHistory: ['Date', 'Time', 'Stage', 'Person']
        });

        this.listenTo(this.model, 'change', this.render);
        this.onResize();

        return this;
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize() {
        $(window).bind('resize', () => {
            this.resizeGrid();
        })
    }

    setRow(rowid){
        this.model.set({
            rowid: rowid
        }, {silent: true});
    }

    notificationOnCellSelect(rowid, iCol, cellcontent, e) {
        console.log('Notification CLicked');
        $(this.gridElNotifications).jqGrid('setSelection', rowid);
    }

    notificationOnSelectRow(rowId, status, e) {
        console.log('Notification Selected');
    }

    notificationOnDblClickRow(rowId) {
        console.log('Notification Double CLicked');
    }

    notificationGridComplete(){
        $(this.gridElNotifications + " tr.jqgrow:odd").css("background", "#DDDDDC");
    }

    notificationAfterSaveCell(){
        console.log("Notification After Save Cell");
    }

    historyOnCellSelect(rowid, iCol, cellcontent, e) {
        //    view.onCellSelect(rowid, iCol, cellcontent,e);
        console.log('History CLicked');
    }

    historyOnSelectRow(rowId, status, e) {
        console.log('History Selected');
    }

    historyOnDblClickRow(rowId) {
        console.log('History Double CLicked');
    }

    historyGridComplete(){
        $(this.gridElHistory + " tr.jqgrow:odd").css("background", "#DDDDDC");
    }

    historyAfterSaveCell(){
        console.log("History After Save Cell");
    }

    getHistoryProperties() {
        return{
            onCellSelect:this.historyOnCellSelect,
            onSelectRow:this.historyOnSelectRow,
            ondblClickRow:this.historyOnDblClickRow,
            gridComplete:this.historyGridComplete,
            afterSaveCell:this.historyAfterSaveCell,
            colNames:this.model.get('colNamesHistory'),
            colModel:this.model.get('colModelHistory')
        }
    }

    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    getNotificationsProperties() {
        return{
            onCellSelect:this.notificationOnCellSelect,
            onSelectRow:this.notificationOnSelectRow,
            ondblClickRow:this.notificationOnDblClickRow,
            gridComplete:this.notificationGridComplete,
            afterSaveCell:this.notificationAfterSaveCell,
            colNames:this.model.get('colNamesNotifications'),
            colModel:this.model.get('colModelNotifications')
        }
    }

    deleteFormInstance(ev) {         
        dashboardService.deleteInstance();
    }

    viewForm() {
        
        const instanceUrl = restService.getLinkUrl(this.model.get('formInstanceId')) + '&viewForm=true';
        const attributes = {url: instanceUrl, id: this.model.get('formInstanceId') };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        newPlayForm.render().then((result) => {});

    }

    dataHistory(ev) {    
        const name = this.model.get('name');
        const firstDate = util.formatExpressionShortDate(this.model.get('firstSubmissionDate'));
        restService.getFormDataHistory(this.model.get('instanceId')).then((data)=>{
            const attributes = {subtitle:'Data History - ' + name + ' (' + firstDate + ')' , 
                                dataHistory: data};
            let newDatahistoryForm = new DataHistoryModal({model: new Model(attributes) });
            newDatahistoryForm.render().then((result)=>{
            }).catch((err)=> {
                console.log('Error in Data History', err);
            });
        });
    }

    refresh(){
        eventBus.trigger(constants.EV_REFRESH_FORM_INSTANCE_DETAILS,this.model.get('instanceId'),this.model.get('formInstanceId'))
    }    

    goToForms(e) {
         e.preventDefault();
         e.stopPropagation();
 
         eventBus.trigger("loadFormsView");
     }
 
    goToEditForms(e) {
         e.preventDefault();
         e.stopPropagation();
 
         eventBus.trigger("displayDefaultEditFormsDetailView");        
    }

    migrateFormInstance(e){
        e.preventDefault();
        e.stopPropagation();
        const formInstanceId = this.model.get('instanceId');
        const name = this.model.get('name') + ' (' + util.formatExpressionShortDate(this.model.get('lastSubmissionDate')) + ')';
        let mfiModal = new MigrateFormInstanceModal();
        mfiModal.render().then((type) => {
            if (type && type !== '') {
                restService.exportFormResponseData(formInstanceId, type, name);
            }
        }).catch(err => console.log(err));
    }

    render() {
        let notificationData = this.model.get('notificationData');
        let historyData = this.model.get('historyData');

        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let self = this;
        let notificationsGridObject = util.getGridObject(self,self.getNotificationsProperties());
        let historyGridObject = util.getGridObject(self,self.getHistoryProperties());
        $(self.gridElNotifications).jqGrid(notificationsGridObject);
        $(self.gridElHistory).jqGrid(historyGridObject);


        if(notificationData.length){
            $("#noNotifications").hide();
            $("#notifications").show();
        }
        else{
            $("#noNotifications").show();
            $("#notifications").hide();
         }

         if(notificationData) {
             notificationData.forEach(function (value, index) {
                 var newRow = {
                     'date': util.toLocalDateTime( value['@Date'], 'DD MMM YYYY'),
                     'time': util.toLocalDateTime( value['@Date'], 'HH:mm'),
                     'title': value['@Name'],
                     'person': value['@Person'],
                     'attentionLevel': util.getAttentionLevel(value["@AttentionLevel"]),
                     'notificationId': value['@NotificationId']
                 };
                 $(self.gridElNotifications).addRowData(index, newRow);//
             });
         }
         
        if(historyData) {
            historyData.forEach(function (value, index) {
                var newRow = {
                    'date': util.toLocalDateTime( value['@Date'], 'DD MMM YYYY'),
                    'time': util.toLocalDateTime( value['@Date'], 'HH:mm'),
                    'stage': value['@StageName'],
                    'person': value['@PersonName']
                };
                $(self.gridElHistory).addRowData(index, newRow);//
            });
        }


        this.resizeGrid();
        this.delegateEvents();

        //this.afterRender();
        this.$el.css('cursor', 'default');
        return this;
    }
}

export default EditFormsViewableInstanceDetailView;

